export default __webpack_public_path__ + "media/images/images/portfolio/width-600/portfolio-22-7872f2ef1c86d4a1bc2d38bf8d437a01.jpg";